import { render } from "./Header.vue?vue&type=template&id=4178385e&scoped=true&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=4178385e&scoped=true&lang=css"

import exportComponent from "/var/www/rewards/runners/admin/root/reward-admin/reward-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4178385e"]])

export default __exports__